import { isShowEvent } from '../event/utils';
import logo from '../assets/LogoMobile.png';
import logoEvent from '../assets/LogoEventMobile.webp';

export const LogoMobile = ({
  className,
  onClick,
  role,
  isShowOriginLogo
}: {
  className?: string;
  onClick?: () => void;
  role?: string;
  isShowOriginLogo?: boolean;
}) => {
  return !isShowOriginLogo && isShowEvent('LOGO') ? (
    <img src={logoEvent} className={className} alt="logo" onClick={onClick} role={role} />
  ) : (
    <img src={logo} className={className} alt="logo" onClick={onClick} role={role} />
  );
};
